import React from 'react';
import { FileSignatureIcon } from 'lucide-react';
import type { ESignPackage } from '../types/docmagic';
import { derivePackageStatus } from '../utils/packageStatus';
import { formatDateTime } from '../utils/datetime';
import { StatusBadge } from './StatusBadge';
interface PackageListProps {
  items: ESignPackage[];
  selectedId: string;
  onSelect: (id: string) => void;
}
export function PackageList({
  items,
  selectedId,
  onSelect
}: PackageListProps) {
  const groups = [{
    title: 'Matched to this loan',
    items: items.filter(p => p.matchStatus === 'Matched')
  }, {
    title: 'Manual review queue',
    items: items.filter(p => p.matchStatus === 'Unmatched')
  }].filter(g => g.items.length > 0);
  return <nav aria-label="DocMagic packages" className="rounded border border-line bg-white shadow-sm" data-id="element-124" data-mp="2073r8dn44mt0">
      <div className="flex items-center gap-2 border-b border-line px-4 py-3" data-id="element-125" data-mp="2eps1bepafpg">
        <FileSignatureIcon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-126" data-mp="3ujjwbb469uwa" />
        <h2 className="text-sm font-bold text-ink" data-id="element-127" data-mp="c2ptndbt4940">DocMagic eSign Packages ({items.length})</h2>
      </div>
      {groups.map(group => <div key={group.title} data-id="element-128" data-mp="h2c81q3dfvee">
          <p className="bg-canvas px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-muted" data-id="element-129" data-mp="gz6iyauqstio">
            {group.title}
          </p>
          <ul data-id="element-130" data-mp="74elr852o8of">
            {group.items.map(pkg => {
          const active = pkg.id === selectedId;
          return <li key={pkg.id} data-id="element-131" data-mp="utpogv5zgd57">
                  <button type="button" onClick={() => onSelect(pkg.id)} aria-current={active ? 'true' : undefined} className={`w-full border-l-[3px] px-4 py-3 text-left transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand ${active ? 'border-brand bg-[#eef4ff]' : 'border-transparent hover:bg-[#f9f9f9]'}`} data-id="element-132" data-mp="zrr9vmqvsoju">
                    <div className="flex items-start justify-between gap-2" data-id="element-133" data-mp="1sf0q8f7hmnh3">
                      <span className="text-[11px] font-semibold uppercase tracking-wide text-muted" data-id="element-134" data-mp="1sc632fx3aojz">{pkg.type}</span>
                      <StatusBadge status={derivePackageStatus(pkg)} size="sm" data-id="element-135" data-mp="1jdkhsd08gvfi" />
                    </div>
                    <p className={`mt-1 text-sm leading-snug ${active ? 'font-semibold text-brand-dark' : 'text-ink'}`} data-id="element-136" data-mp="1ef96ryy7cevp">
                      {pkg.title}
                    </p>
                    <p className="mt-1 font-mono text-[11px] text-muted" data-id="element-137" data-mp="14oy2uceiq5ot">
                      {pkg.docMagicPackageId} · {formatDateTime(pkg.lastSyncedAt)}
                    </p>
                  </button>
                </li>;
        })}
          </ul>
        </div>)}
    </nav>;
}